import React from "react";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./style";
import DrawerAddPayment from "./DrawerAddPayment";
import DrawerHistory from "./DrawerHistory";
import {
  currentSelectedPaymentId,
  currentSelectedPaymentStatus,
} from "src/app-redux/commercial/commercialSlice";
import { getPaymentDetailsById } from "src/app-redux/commercial/actions/commercialActions";
import DrawerGatePass from "./gatePass";

export interface IProps {
  isDrawerOpen: boolean;
  handleCloseDrawer: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value != index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value == index && (
        <Box p={1} style={{ marginTop: "10px" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Drawer(props: IProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const selectedPaymentStatus = useAppSelector(currentSelectedPaymentStatus);
  const selectedPaymentId = useAppSelector(currentSelectedPaymentId);

  const [value, setValue] = React.useState(2);

  React.useEffect(() => {
    selectedPaymentStatus == "Void" ? setValue(2) : setValue(0);
  }, [selectedPaymentStatus, props]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <CommonDrawer
        heading={"Payment Received"}
        isOpen={props.isDrawerOpen}
        closeDrawer={() => {
          setValue(0);
          props.handleCloseDrawer();
        }}
        drawerWidth={450}
        iconCallBackFun={() => {
          dispatch(getPaymentDetailsById(selectedPaymentId));
        }}
        border={true}
      >
        <div className={classes.mainDrawer}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.DrawerTabs}
            >
              <Tab
                label="Add Payment"
                {...a11yProps(0)}
                disabled={selectedPaymentStatus == "Void"}
              />
              <Tab label="Gate Pass" {...a11yProps(1)} disabled={selectedPaymentStatus != "Paid"} />
              <Tab label="History" {...a11yProps(2)} />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0} dir={theme.direction}>
            <DrawerAddPayment />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <DrawerGatePass />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <DrawerHistory />
          </TabPanel>
        </div>
      </CommonDrawer>
    </>
  );
}
